
export const SEND_REPORT_OTP = "SEND_REPORT_OTP"
export const SEND_REPORT_OTP_SUCCESS = "SEND_REPORT_OTP_SUCCESS"
export const SEND_REPORT_OTP_FAILED = "SEND_REPORT_OTP_FAILED"


export const VERIFY_REPORT_OTP = "VERIFY_REPORT_OTP"
export const VERIFY_REPORT_OTP_SUCCESS = "VERIFY_REPORT_OTP_SUCCESS"
export const VERIFY_REPORT_OTP_FAILED = "VERIFY_REPORT_OTP_FAILED"
export const RESET_VERIFY_REPORT = "RESET_VERIFY_REPORT"